<template>
    <!-- table -->
    <div class="qt-full-table">
      <table>
        <tr>
          <th>Details</th>
          <th>Value</th>
          <th style="text-align: left;">Unit</th>
        </tr>
        <tr>
          <td>Hours Balance Last Year</td>
          <td>{{(employeeTimeOverview.overHoursLastYear).toFixed(2)}}</td>
          <td style="text-align: left;">Hrs</td>
        </tr>
        <tr>
          <td>Hours Balance Current Year</td>
          <td>{{(employeeTimeOverview.overHoursThisYear).toFixed(2)}}</td>
          <td style="text-align: left;">Hrs</td>
        </tr>
        <tr>
          <td>Sum Of All Over Hours</td>
          <td>{{(employeeTimeOverview.sumofOverHours).toFixed(2)}}</td>
          <td style="text-align: left;">Hrs</td>
        </tr>
        <!-- <tr>
          <td>Target Billable Days</td>
          <td>{{employeeTimeOverview.targetBillableDays}}</td>
          <td style="text-align: left;">Days</td>
        </tr> -->
        <tr>
          <td>Sum Of Recorded Billable Days</td>
          <td>{{(employeeTimeOverview.sumRecordedBillable).toFixed(2)}}</td>
          <td style="text-align: left;">Days</td>
        </tr>
        <!-- <tr>
          <td>Current target reached in percent</td>
          <td>{{employeeTimeOverview.targetInPerc}} %</td>
        </tr> -->
        <tr>
          <td>Travel Time</td>
          <td>{{(employeeTimeOverview.travelTime).toFixed(2)}}</td>
          <td style="text-align: left;">Hrs</td>
        </tr>
      </table>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
       
      };
    },
    beforeMount(){
    this.$store.dispatch("EmployeeTimeoverview");
    },
    computed: {
            employeeTimeOverview: function () {
                return this.$store.state.qtimeReports.employeeTimeoverview;
            }
    }
  };
  </script>
  